import { Stack, styled } from "@mui/material";

export const StyledStack = styled(Stack)`
  display: flex;
  flex-wrap: wrap;
`;
